import { AppBar, Toolbar, Button, Box, IconButton } from '@mui/material';
import { styled } from '@mui/system';

export const StyledAppBar = styled(AppBar)(({ theme }) => ({
  background: theme.palette.mode === 'dark'
    ? (theme.custom?.gradients?.brand || 'linear-gradient(90deg, #1A2980 0%, #26D0CE 100%)')
    : 'linear-gradient(90deg, #1e3c72 0%, #2a5298 100%)',
  boxShadow: 'none',
  transition: 'all 0.3s ease-in-out',
}));

export const StyledToolbar = styled(Toolbar)({
  justifyContent: 'space-between',
});

export const NavButtons = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

export const NavButton = styled(Button)(({ theme }) => ({
  color: theme.palette.common.white,
  marginLeft: '1rem',
  position: 'relative',
  '&::after': {
    content: '""',
    position: 'absolute',
    width: '0',
    height: '2px',
    bottom: 0,
    left: '50%',
    background: theme.palette.secondary.main,
    transition: 'all 0.3s ease-in-out',
  },
  '&:hover::after': {
    width: '100%',
    left: '0',
  },
}));

export const ThemeToggle = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginLeft: '1rem',
}));

export const MobileMenuButton = styled(IconButton)(({ theme }) => ({
  display: 'none',
  [theme.breakpoints.down('md')]: {
    display: 'block',
  },
}));
